module.exports = __webpack_public_path__ + "media/packs/controllers/components/general/sprite-7d6cd08ed8ec60621d35ae932c7eb3db.svg";